class DataUrlGeneratorInterface {
    /*
        @param  url (string)  URL pointing to the resource to be converted into a data url

        @return
            {
                data_url: <string>,
                is_error: <boolean>
            }
    */
    generate = async (url) => {
        throw new Error("generate method not implemented");
    }
}

export default DataUrlGeneratorInterface;